import { models } from "powerbi-client";

/** Converte o tipo informado pela API para o tipo esperado pelo SDK do Power BI. */
export function tipoDeTokenPowerBi(tipo?: string): models.TokenType {
  return tipo === "Embed" ? models.TokenType.Embed : models.TokenType.Aad;
}
